import Axios, { AxiosRequestConfig } from 'axios';
import moment from 'moment-timezone';
import { API_URL } from '@/config';
import { showNotification } from '@/utils/notificationUtils';
import storage from '@/utils/storage';



async function authRequestInterceptor(config: AxiosRequestConfig) {
  const pathArray = window.location.pathname.split('/');
  const token = storage.getToken();
  
  if (config.headers['authorization']) {
    config.headers.authorization = `${config.headers['authorization']}`;
  }
  else if (token) {
    config.headers.authorization = `${token}`;
  }
  config.headers.Accept = 'application/json';
  config.headers['Cache-Control'] = 'no-cache';
  config.headers.Pragma = 'no-cache';
  config.headers.Expires = '0';
  config.headers.tz=moment.tz.guess(true);
  config.headers['loc-id'] = config.headers['loc-id']
    ? config.headers['loc-id']
    : storage.getKey(`loc_id_${pathArray[1]}`);
  config.params = { ...config.params, _: Date.now() };

  let csrf = localStorage.getItem('csrf');

  if (!csrf) {
    const res = await Axios.get(`${API_URL}/csrf`, { withCredentials: true });
    csrf = res.headers['x-csrf-token'];
  }

  config.headers['x-csrf-token'] = csrf;

  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    if (response.headers['x-csrf-token']) {
      localStorage.setItem('csrf', response.headers['x-csrf-token']);
    }

    if (response?.data?.result?.status) {
      return response.data.responseData;
    } else {
      const message = response?.data?.errors[0]?.message;
      showNotification({
        type: 'error',
        title: message,
      });
      return Promise.reject(response?.data);
    }
  },
  (error) => {
    if (
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message)
    ) {
      let message = error.response?.data?.message || error.message;
      if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
        message = `${error.response?.data?.errors[0]?.message}`;
        if (message.includes('field is required') > 0) {
          message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
        }
      }
      showNotification({
        type: 'error',
        title: message,
      });
    }

    return Promise.reject(error);
  }
);
